import React from "react";
import * as Styled from "./RollAdsModalHeader.styled";
import { HeaderLogo } from "../../../../../libs";
import CloseIcon from "../../../../../assets/images/icons/close.png"


interface RollAdsModalHeaderProps {
  onClose: () => void;
}

export const RollAdsModalHeader: React.FC<RollAdsModalHeaderProps> = ({ onClose }) => {
  return (
    <Styled.ModalHeader>
      <Styled.HeaderLeft>
        <HeaderLogo />
      </Styled.HeaderLeft>
      <Styled.RightSection>
        <Styled.BackText onClick={onClose}>Back to Ad Server</Styled.BackText>
        <Styled.CloseButton onClick={onClose}>
          <Styled.CloseIconImage src={CloseIcon} alt="Close"/>
        </Styled.CloseButton>
      </Styled.RightSection>
    </Styled.ModalHeader>
  );
};
